import { Pencil, Trash2, Clock, User } from "lucide-react";
import { Button } from "../../ui/button";
import { eventTypeLabel } from "./eventTypes";

const formatDateLabel = (dateStr) => {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("es-MX", { weekday: "short", day: "numeric", month: "short" });
};

export const EventListItem = ({ event, onEdit, onDelete }) => (
  <div
    data-testid={`event-list-item-${event.id}`}
    className="flex items-start justify-between gap-4 rounded-lg border p-4"
  >
    <div className="flex-1 min-w-0">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-xs font-medium uppercase tracking-wide bg-secondary px-2 py-0.5 rounded">
          {eventTypeLabel(event.event_type)}
        </span>
        <span className="text-sm font-medium capitalize">{formatDateLabel(event.date)}</span>
        <span className="text-sm text-muted-foreground flex items-center gap-1">
          <Clock size={13} /> {event.start_time} - {event.end_time}
        </span>
      </div>
      <p className="text-sm mt-2 flex items-center gap-1">
        <User size={13} className="text-muted-foreground" /> {event.client_name}
      </p>
      {event.notes && <p className="text-xs text-muted-foreground mt-1">{event.notes}</p>}
    </div>
    <div className="flex gap-2 shrink-0">
      <Button data-testid={`event-edit-${event.id}`} size="icon" variant="ghost" onClick={onEdit}>
        <Pencil size={15} />
      </Button>
      <Button data-testid={`event-delete-${event.id}`} size="icon" variant="ghost" onClick={onDelete}>
        <Trash2 size={15} className="text-destructive" />
      </Button>
    </div>
  </div>
);
